export default __webpack_public_path__ + "static/media/beep-09.cad0d1eb.ogg";